import { ViewFactory } from 'wdc-cube-react'
import BorderoFormScope from '../bordero_form.scopes'
import BorderoFormView from './bordero_form.view'

export function registerViews(rv = ViewFactory.register) {
    rv(BorderoFormScope, BorderoFormView)
}
